/**
 * Created by olga on 26.06.2024
 */

const PuzzlesComponent = cc.Node.extend({
    ctor: function (collection) {
        this._super();

        this.collection = collection;
        this.stickers = [];
        this.newStickers = [];

        this.createPlaceholders(collection.stickers);
        this.createStickerViews(collection.stickers);

        this.newPuzzlesSlots = new NewPuzzlesSlotsView(this);

        const layout = new cleverapps.Layout([this.puzzleBg, this.newPuzzlesSlots], {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.PuzzlesComponent.margin
        });

        this.addChild(layout);
        this.setContentSize(layout.width, layout.height);
        layout.setAlignment(this.width / 2, this.height / 2);

        this.setAlignment(cleverapps.styles.PuzzlesComponent);

        this.collection.on("complete", this.onCompleteAnimation.bind(this), this);
    },

    createPlaceholders: function (stickers) {
        const styles = cleverapps.styles.PuzzlesComponent;
        const puzzleBg = this.puzzleBg = new cc.Sprite(bundles.stickers_collection_window.frames.puzzle_bg_png);
        puzzleBg.setLocalZOrder(1);

        this.placeholders = [];
        stickers.forEach(() => {
            const placeholder = new cc.Node();
            placeholder.setAnchorPoint(0.5, 0.5);
            placeholder.setContentSize2(styles.placeholder);
            this.placeholders.push(placeholder);
        });

        const layout = new cleverapps.GridLayout(this.placeholders, {
            columns: PuzzlesComponent.COLLUMNS_AMOUNT
        });
        layout.setLocalZOrder(1);

        layout.setAlignment(styles.layout);
        puzzleBg.addChild(layout);
    },

    createStickerViews: function (stickers) {
        stickers.forEach((sticker, index) => {
            const ViewClass = sticker.getViewClass();
            const stickerView = new ViewClass(sticker, {
                placeholder: this.placeholders[index],
                withUpdate: true
            });

            if (sticker.hasAttention()) {
                this.addControls(stickerView);
                this.newStickers.push(stickerView);
            } else {
                this.putUpPuzzle(stickerView);
            }
            this.stickers.push(stickerView);
        });
    },

    onCompleteAnimation: function () {
        const styles = cleverapps.styles.PuzzlesComponent.puzzleCompleteAnimation;
        const animation = new cleverapps.Spine(bundles.sticker.jsons.puzzle_light_win_json);

        animation.setLocalZOrder(12);
        this.addChild(animation);
        animation.setAlignment(styles);
        animation.setAnimation(0, "animation", false);
        animation.setCompleteListenerRemove();

        cleverapps.effects.fire("stickers.puzzle.put.final");
    },

    putUpPuzzle: function (stickerView, fromSlot) {
        stickerView.replaceParent(stickerView.placeholder);

        stickerView.setScale(1);
        stickerView.setAlignment(cleverapps.styles.PuzzleStickerView.position);
        stickerView.shadow.setLocalZOrder(0);
        stickerView.shadow.replaceParentSamePlace(this.puzzleBg);

        if (fromSlot) {
            stickerView.placeholder.setLocalZOrder(0);
            stickerView.sticker.setAttention(false);
            stickerView.pointHandler.remove();
            stickerView.pointHandler = undefined;
            this.newStickers.splice(this.newStickers.indexOf(stickerView), 1);
            this.newPuzzlesSlots.takeStickerFromSlot(stickerView);
            stickerView.animatePutUp();
        } else if (stickerView.sticker.isOpen()) {
            stickerView.removeRarityIndicator();
        }
    },

    addControls: function (stickerView) {
        stickerView.pointHandler = cleverapps.UI.onDrag(stickerView, {
            instantDrag: true,
            followPointer: true,
            onDragStart: this.createListener(this.onDragStart.bind(this, stickerView)),
            onDragEnd: this.createListener(this.onDragEnd.bind(this, stickerView))
        });
    },

    onDragStart: function (stickerView) {
        if (this.dragging) {
            return false;
        }

        this.dragging = true;
        const window = cleverapps.focusManager.currentWindow();
        window.removeStickerTooltip();
        this.newPuzzlesSlots.setDisableScroll(true);

        stickerView.animateDragStart();
        return true;
    },

    onDragEnd: function (stickerView) {
        const position = stickerView.calculateViewPosition();
        if (cc.rectContainsPoint(stickerView.placeholder.getGlobalBoundingBox(), position)) {
            this.putUpPuzzle(stickerView, true);
            this.dragging = false;
            this.newPuzzlesSlots.setDisableScroll(false);
        } else {
            stickerView.animateEndDrag({
                animateWrong: cc.rectContainsPoint(this.puzzleBg.getGlobalBoundingBox(), position),
                callback: function () {
                    this.dragging = false;
                    this.newPuzzlesSlots.setDisableScroll(false);
                }.bind(this)
            });
        }
    },

    onClose: function () {}
});

PuzzlesComponent.COLLUMNS_AMOUNT = 3;

cleverapps.styles.PuzzlesComponent = {
    x: { align: "center" },
    y: { align: "center", dy: -50 },

    placeholder: {
        width: 241,
        height: 241
    },

    margin: 20,

    layout: {
        x: { align: "center", dx: 2 },
        y: { align: "center", dy: 2 }
    },

    puzzleCompleteAnimation: {
        x: { align: "center", dx: 5 },
        y: { align: "center", dy: 135 }
    }
};